/*
--------------------------------
 ## blog page ajax Pagination
--------------------------------
*/
$(document).on("click", ".js-load-more", function(){
  var $this =$(this),totalPages = parseInt($('[data-total-pages]').val()),currentPage = parseInt($('[data-current-page]').val());
  $this.attr('disabled', true);
  $this.find('[load-more-text]').addClass('hide');
  currentPage = currentPage + 1;
  var nextUrl = $('[data-next-url]').val().replace(/page=[1-25]+/,'page='+currentPage);
  $('[data-current-page]').val(currentPage);
  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      var responce = $(responseHTML).find('.js-article-grid');
$(responce).find(".grid__item.one-whole.article--latest").removeClass("one-whole").addClass("one-half");
      $('.js-article-grid').append(responce.html());
      window.setGridHeight('.grid .grid__item .title_wrap');
    },
    error: function(e){
      console.log(e);
    },
    complete: function() {
      if(currentPage <= totalPages) {
         $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
      } 
    }
  })
});


/*--------------------------------*/

function openTab(evt, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tab_content");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  console.log(tabName);
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " active";
}

$(document).scroll(function () {
  var y = $(this).scrollTop();
  if (y > 600) {
    $('.back-to-top-wrapper').fadeIn();
  } else {
    $('.back-to-top-wrapper').fadeOut();
  }
});

$(function () {
  if ($(window).width() < 1024) {
    $('.mfp-image').click(function () {
      $.magnificPopup.open({
        items: {
          src: $(this).attr('src')
        },
        type: 'image'
      });
    })
  }
  else {
    $('.product-single__media').zoom({
      url: $(this).find('img').attr('data-zoom'),
      callback: function () {
        $(this).magnificPopup({
          type: 'image',
          items: {
            src: $(this).attr('src')
          }
        });
      }
    });
  }
});

$(function () {
  $('.popup-modal').magnificPopup({
    type: 'inline',
    preloader: false,
    modal: true
  });
  $(document).on('click', '.popup-modal-dismiss', function (e) {
    e.preventDefault();
    $.magnificPopup.close();
  });
});

function showtooltip() {
  var mouseTarget = document.querySelector('.icon_show_tooltip');
  if (mouseTarget) {
    if (screen.width > 768) {
      mouseTarget.addEventListener("mouseover", (event) => {
        document.querySelector('.tooltip_rewards').classList.add('show_tooltip');
      });
      mouseTarget.addEventListener("mouseout", (event) => {
        document.querySelector('.tooltip_rewards').classList.remove('show_tooltip');
      });

    } else {
      mouseTarget.addEventListener("click", (event) => {
        document.querySelector('.tooltip_rewards').insertAdjacentHTML('afterbegin', '<div class="close_tooltip">X</div>');
        document.querySelector('.tooltip_rewards').classList.add('show_tooltip');
        document.querySelector('.overlay_tooltip').classList.add('show_tt');

        document.querySelector('.close_tooltip').addEventListener("click", (event) => {
          document.querySelector('.tooltip_rewards').classList.remove('show_tooltip');
          document.querySelector('.overlay_tooltip').classList.remove('show_tt');
        });
      });
    }
  }
}
showtooltip();



window.setGridHeight = (selector) =>{
  this.heightArray = [];
  this.offsetArrayArray = [];
  this.sectionArray = [];


  document.querySelectorAll(selector).forEach((grid,i)=>{
    var tmp = {'index':i,'offsetheight':grid.closest(`[data-equal]`).offsetTop};
    this.offsetArrayArray.push(tmp)
  });

  this.diffrentsHeights = []
  this.offsetArrayArray.forEach(function(e){
    if(this.diffrentsHeights.includes(e.offsetheight) == false){
      this.diffrentsHeights.push(e.offsetheight)
    }
  })

  this.diffrentsHeights.forEach(function(e){
    var data = [];
    for(var i = 0; i < this.offsetArrayArray.length; i++){
      if(this.offsetArrayArray[i].offsetheight == e){
        data.push(this.offsetArrayArray[i]);
      }
    }

    var getAllHeightArray = [];
    data.forEach(function(ele){
      document.querySelectorAll(selector)[ele.index].removeAttribute('style');
      getAllHeightArray.push(document.querySelectorAll(selector)[ele.index].offsetHeight);
    })

    var getMaxHeight = Math.max.apply(Math, getAllHeightArray);
    data.forEach(function(ele){
      document.querySelectorAll(selector)[ele.index].style.minHeight = getMaxHeight+'px';
    });
  })

}

window.setGridHeight('.grid .grid__item .title_wrap');
// window.setGridHeight('.grid .grid__item .one-half .title_wrap');